var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spaceCenter common" }, [
    _c("div", [
      _c("div", { staticClass: "spaceLeft item-box" }, [
        _c("label", [_vm._v("融资金额：")]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "text-color-gold",
            staticStyle: { "margin-right": "5px" }
          },
          [_vm._v(_vm._s(_vm._f("splitK")(_vm.modalData.applyAmt)) + " ")]
        ),
        _vm._v(" 元\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceLeft item-box" },
        [
          _c("label", [_vm._v("交易密码：")]),
          _vm._v(" "),
          _c("a-input", {
            staticClass: "item-input",
            attrs: { type: "password" },
            model: {
              value: _vm.txnPwd,
              callback: function($$v) {
                _vm.txnPwd = $$v
              },
              expression: "txnPwd"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter model-footer-btns" },
        [
          _c(
            "a-button",
            { staticClass: "btn-big", on: { click: _vm.modalCancel } },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "btn-big",
              attrs: {
                type: "primary",
                loading: _vm.modalLoad,
                disabled: !_vm.txnPwd
              },
              on: { click: _vm.modalOk }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e62c712", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e62c712","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/circulation/gold-financing/finance-password-modal.vue
// module id = Zy8D
// module chunks = 1